import React from 'react'
import CustomizedInput from '../CreateForm/InputBase';
import './style.scss'

interface counterInputProps {
    maxCount: number;
    placeHolder: string;
    value: string;
    onChangeHandler: (value: string) => void;
}

const InputWithCounter: React.FC<counterInputProps> = ({ maxCount, placeHolder, value, onChangeHandler }) => {
    return (
        <div className='InputWithCounter-container'>
            <div className='counter-container'><span>{value?.length}/{maxCount}</span></div>
            <CustomizedInput
                placeholder={placeHolder}
                value={value ?? ""}
                onChange={(e: any) => onChangeHandler(e.target.value)}
                type="text"
                inputProps={{ maxLength: maxCount }}
            />
        </div>
    )
}

export default InputWithCounter